import React, { Component, Fragment } from "react";
import { fetchAppealDetailData, revoke, supply } from "../../services/services";
import PunishCard from "../../components/punishCard";
import PunishmentSubsidiary from "../../components/punishmentSubsidiary";
import Bounced from "../../components/bounced";
import Loading from "../../components/loading";
import { getQueryString } from "../../utils/utils";
import { burying } from "../../utils/buryPoint";
import GeneralButton from "../../components/generalButton";

import back from "../../static/images/back.png";
import { message } from "antd";
import {
  appealDetailType,
  punishDetialType,
} from "../../services/interfaceType";
import styles from "./index.less";

interface Props {
  history: any;
}

interface State {
  content: string;
  attachmentJson: string;
  appealDetailData: appealDetailType;
  punishMoreData: punishDetialType[];
  modalType: boolean;
  revokeType: boolean;
  errorTip: string;
  docTip: any;
  attachmentClear: boolean;
  loading: boolean;
  submit: boolean;
}
class Appeal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      content: "",
      attachmentJson: "",
      appealDetailData: {},
      punishMoreData: [],
      modalType: false,
      revokeType: false,
      errorTip: "",
      docTip: [],
      attachmentClear: false,
      loading: true,
      submit: true,
    };
  }

  componentDidMount() {
    document.body.scrollTop = 0;
    const templateId = getQueryString("templateId");
    const caseId = getQueryString("caseId");
    this.getAppealDetailData(caseId, templateId);
  }

  /**
   * @description 撤销弹框
   *
   **/
  setRevokeType = () => {
    const caseId = getQueryString("caseId");
    this.setState({
      revokeType: !this.state.revokeType,
    });
    document.body.scrollTop = 0;
    burying("2", "revoke-appeal-detail", `button=0$status=${this.state.appealDetailData.appealStatus}$appealid=${caseId}`, "ss-05", "undefined");
  };

  /**
   * @description 补充资料弹框
   *
   **/
  setModalType = async () => {
    await this.setState({
      attachmentClear: !this.state.attachmentClear,
    });
    await this.setState({
      modalType: !this.state.modalType,
    });
    this.setState({
      errorTip: "",
      docTip: [],
    });
    document.body.scrollTop = 0;
  };

  changSubmitStatus = (status) => {
    this.setState({
      submit: status,
    });
  };

  /**
   * @description 补充资料
   *
   **/
  submitAdditionalInfo = async () => {
    const { content, attachmentJson, submit } = this.state;
    const templateId = getQueryString("templateId");
    const caseId = getQueryString("caseId");
    const params = {
      caseId,
      templateId,
      content,
      spTemplateId: getQueryString('spTemplateId'),
      attachmentJson: JSON.stringify(attachmentJson),
    };
    if (content && attachmentJson && submit) {
      const result = await supply(params);
      if (result.code === 0) {
        this.getAppealDetailData(caseId, templateId);
        this.setModalType();
      } else {
        message.info(result.msg);
      }
      burying("2", "submit-appeal-add", `valid=1$appealid=${caseId}`, "ss-05", "undefined");
    } else {
      if (!content) {
        this.setState({
          errorTip: "请填写问题描述",
        });
      }
      if (!attachmentJson) {
        this.setState({
          docTip: "请上传附件",
        });
      }
    }
  };

  /**
   * @description 撤销
   *
   **/
  revockApplication = async () => {
    const templateId = getQueryString("templateId");
    const caseId = getQueryString("caseId");
    const params = {
      templateId,
      caseId,
      spTemplateId: getQueryString("spTemplateId")
    };
    const result = await revoke(params);
    if (result.code === 0) {
      this.getAppealDetailData(caseId, templateId);
      this.setRevokeType();
    } else {
      message.info(result.msg);
    }
    burying("2", "revoke-appeal-detail", `button=1$status=${this.state.appealDetailData.appealStatus}$appealid=${caseId}`, "ss-05", "undefined");
  };

  /**
   * @description 返回列表页
   *
   **/
  linkToList = () => {
    this.props.history.goBack();
  };

  /**
   * @description 获取页面输入组件填写数据
   *
   **/
  getValue = (value: any, type: string) => {
    if (type === "description") {
      value !== ""
        ? this.setState({
          errorTip: "",
        })
        : null;
    }
    if (type === "picUrl") {
      value !== ""
        ? this.setState({
          docTip: "",
        })
        : null;
    }
    switch (type) {
      case "description":
        this.setState({
          content: value,
        });
        break;
      case "picUrl":
        this.setState({
          attachmentJson: value,
        });
        break;
    }
  };

  /**
   * @description 获取详情数据
   *
   **/
  getAppealDetailData = async (
    caseId: string | number,
    templateId: string | number
  ) => {
    const params = {
      caseId,
      templateId,
      spTemplateId: getQueryString("spTemplateId")
    };
    const result = await fetchAppealDetailData(params);
    if (result) {
      if (result.code === 0) {
        this.setState({
          appealDetailData: result.data,
        });
        burying("1", "appeal-detail-page", `status=${result.data.appealStatus}$appealid=${caseId}`, "ss-05", "undefined");
      } else {
        message.info(result.msg);
      }
      this.setState({
        loading: false,
      });
    } else {
      this.props.history.push("/case/home/error");
    }
  };
  onSubmit = () => {
    const { punishList, repeatSubmitType } = this.state.appealDetailData;
    switch (repeatSubmitType) {
      case 2:
        this.props.history.push(`/case/home/appealspentrance?spTemplateId=${getQueryString('spTemplateId')}&ss-fro-3&from=erAppeal`);
        break;
      case 3:
        this.props.history.push(
          `/case/home/appealentrance?templateId=${getQueryString('templateId')}&punishId=${punishList && punishList.length ? punishList[0].punishId : ""}`
        );
        break;
      default:
        return null;
    }
  }

  /**
   * @description 申诉进度卡片渲染
   *
   **/
  appealStatusCard = () => {
    const caseStatus = ["审核中", "已撤诉", "补充资料", "已通过", "已驳回"];
    const { appealStatus, caseId } = this.state.appealDetailData;
    // let  xxzlStus =punishList&&punishList.length ? appealStatus:caseActionLogs[0]?caseActionLogs[0].appealStatus:0;
    // xxzlStus = xxzlStus===0?1:xxzlStus;
    return (
      <div className={styles.appealCard}>
        <div className={styles.appealStauts}>
          {caseStatus[appealStatus - 1]}
        </div>
        <span className={styles.appealNumber}>申诉单号：{caseId}</span>
      </div>
    );
  };
  handleOnline = () => {
    window.open('https://ai.58.com/pc/#/entry/business_type=business127&joinfrom=127pc&client_type=pc')
  }

  render() {
    const {
      punishList,
      caseActionLogs,
      appealStatus,
      caseTime,
      caseTypeName,
      allowRepeatSubmit,
      caseType
    } = this.state.appealDetailData;
    const {
      modalType,
      revokeType,
      errorTip,
      docTip,
      attachmentClear,
      loading,
    } = this.state;
    return (
      <Fragment>
        {modalType ? (
          <div className={styles.modal}>
            <Bounced
              type="additionalInfo"
              cancelBounced={this.setModalType}
              confirm={this.submitAdditionalInfo}
              buttonLeft="提交"
              buttonRight="取消"
              errorTip={errorTip}
              docTip={docTip}
              getValue={this.getValue}
              modalType={attachmentClear}
              changSubmitStatus={this.changSubmitStatus}
            />
          </div>
        ) : null}
        {revokeType ? (
          <div className={styles.modal}>
            <Bounced
              cancelBounced={this.setRevokeType}
              confirm={this.revockApplication}
              bouncedText="撤销申诉，审核将中止确认撤销后，您可重新提交申诉"
              buttonLeft="取消"
              buttonRight="确认撤销申请"
            />
          </div>
        ) : null}
        <div className={styles.appealDetail}>
          <div className={styles.appealTitle}>
            <span className={styles.name}>申诉详情</span>
            {getQueryString('isList') === '1' ? <div className={styles.goBack} onClick={this.linkToList}>
              <img src={back} />
              <span>返回列表</span>
            </div> : null}
          </div>
          {loading ? (
            <Loading />
          ) : (
            <Fragment>
              {this.appealStatusCard()}
              <div className={styles.punishList}>
                <div className={styles.detailContentTitle} style={{ fontSize: '16px' }}>{!punishList.length ? "申诉内容" : '对应处罚'}</div>
                {!punishList.length ?
                  <div style={{ marginTop: '10px' }}>
                    <div>申诉类型: {caseTypeName}</div>
                    <div>申诉日期: {caseTime}</div>
                  </div> :
                  <PunishCard punishDetails={punishList} />}
              </div>
              <div className={styles.punishmentSubsidiary}>
                <div className={styles.punishmentDetails}>进度详情</div>
                {caseActionLogs ? (
                  <PunishmentSubsidiary
                    caseActionLogs={caseActionLogs}
                    getAppealDetailData={this.getAppealDetailData}
                    appealStatus={appealStatus}
                    setModalType={this.setModalType}
                    setRevokeType={this.setRevokeType}
                  />
                ) : null}
              </div>
              {allowRepeatSubmit ? <div className={styles.submitButton}>
                <GeneralButton
                  buttonText={'再次申诉'}
                  type="middle"
                  styleColor="activation"
                  buttonClick={this.onSubmit}
                  grayType={false}
                />
              </div> : ""}
              {/* 如果是是微聊禁言的支持跳转客服 */}
              {!allowRepeatSubmit && appealStatus == 5 ? <div className={styles.tips}>如有疑问，请{caseType === 17 ? <span className={styles.link} onClick={this.handleOnline}>【联系官网客服】</span> : <span>联系官网客服</span>}</div> : ""}
            </Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

export default Appeal;
